import { userHasPermission } from '@/helpers/userPermissions'

export function canViewResponsible(user) {
  return userHasPermission(user, 'responsable.view')
}

export function canInsertResponsible(user) {
  return userHasPermission(user, 'responsable.insert')
}

export function canEditResponsible(user) {
  return userHasPermission(user, 'responsable.edit')
}

export function canDeleteResponsible(user) {
  return userHasPermission(user, 'responsable.delete')
}
